// Quantity for a flat pricing parameter choice. Flat options are labelled
// "<name> <n>" (e.g. "Tires x 4"), and the server prices them as the number in
// the label times the unit price, so the client estimate reads the same number
// (not the option's position in the select, which counts "Select one").
export const flatOptionQuantity = (label) => {
  const match = String(label || '').match(/(\d+(?:\.\d+)?)\s*$/);
  return match ? parseFloat(match[1]) : 0;
};

// The chosen option's text from a flat pricing <select> change event.
export const flatOptionLabel = (event) => {
  const select = event && event.target;
  if (!select) return '';
  const option = select.options && select.selectedIndex > -1 ? select.options[select.selectedIndex] : null;
  return (option && option.text) || select.value || '';
};
